import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import './roleBadge.css';

export const RoleBadge = ({ role, testid }) => {
  const label = role === 'admin' ? 'Admin' : role === 'moderator' ? 'Moderator' : null;
  if (!label) return null;
  return <TooltipProvider delayDuration={120}>
    <Tooltip><TooltipTrigger asChild><span className={`chat-admin-badge${role === 'moderator' ? ' is-moderator' : ''}`} tabIndex={0} aria-label={label} data-testid={testid} data-role={role}><ShieldCheck size={16} strokeWidth={2.3} aria-hidden="true" /></span></TooltipTrigger>
      <TooltipContent side="top" className={`chat-role-tooltip${role === 'moderator' ? ' is-moderator' : ''}`} data-role={role} data-testid={`${testid}-tooltip`}>{label}</TooltipContent>
    </Tooltip>
  </TooltipProvider>;
};

export const AdminBadge = ({ testid }) => <RoleBadge role="admin" testid={testid} />;